import i18n from "i18next";
import {  initReactI18next } from "react-i18next";
import englishJSON from './locales/en.json'
import spanishJSON from './locales/sp.json'
import russianJSON from './locales/ru.json'
import ukrainianJSON from './locales/uk.json'
import { detectBrowserLanguage } from '@/lib/language'
import { languageToLocale } from '@/hooks/useAppLanguage'

i18n.use(initReactI18next).init({
  resources: {
    en: englishJSON,
    es: spanishJSON,
    ru: russianJSON,
    uk: ukrainianJSON,
  },
  // Start in the visitor's browser language so first paint already matches the
  // interface language useAppLanguage settles on — no English flash on load.
  lng: languageToLocale[detectBrowserLanguage()],
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});
